export const FETCH_CARDS_START = 'FETCH_CARDS_START'
export const FETCH_CARDS_SUCCESS = 'FETCH_CARDS_SUCCESS'
export const FETCH_CARDS_ERROR = 'FETCH_CARDS_ERROR'

export const BIND_CARD_START = 'BIND_CARD_START'
export const BIND_CARD_GAME_SUCCESS = 'BIND_CARD_GAME_SUCCESS'
export const BIND_CARD_SUCCESS = 'BIND_CARD_SUCCESS'
export const BIND_CARD_ERROR = 'BIND_CARD_ERROR'

export const FETCH_CARDS_BONUSES_START = 'FETCH_CARDS_BONUSES_START'
export const FETCH_CARDS_BONUSES_SUCCESS = 'FETCH_CARDS_BONUSES_SUCCESS'
export const FETCH_CARDS_BONUSES_ERROR = 'FETCH_CARDS_BONUSES_ERROR'

export const CHANGE_CARD_DESIGN_START = 'CHANGE_CARD_DESIGN_START'
export const CHANGE_CARD_DESIGN_SUCCESS = 'CHANGE_CARD_DESIGN_SUCCESS'
export const CHANGE_CARD_DESIGN_ERROR = 'CHANGE_CARD_DESIGN_ERROR'
